import { useContext, useState, useEffect } from 'react'

import PhotoCameraOutlinedIcon from '@mui/icons-material/PhotoCameraOutlined'

import { PassContext } from "../../../pass-context"
import dataSelector from '../../data-selector'
import PopupEditor from '../../popup-editor'

const HeroImage = () => {
  try {
    const { smartixPassType } = useContext(PassContext)
    const [imageHeight, setImageHeight] = useState(80)
    const [imageSrc, setImageSrc] = useState(null)

    const imageLoaded = e => {
      const img = e.target
      const displayedImageHeight = ((370 / img.width) * img.height) + 5
      setImageHeight(displayedImageHeight)
    }

    const type = smartixPassType === "smartix_stamp" ? "stamp-images" : "image"

    let heroImage = getHeroImage()

    useEffect(() => {
      if (!heroImage) return
      const img = new Image()
      img.crossOrigin = "anonymous"          // important for canvas/color picking
      img.onload = () => {
        setImageSrc(heroImage.value)
      };
      img.onerror = () => setImageSrc(null)
      img.src = heroImage.value                   // set after crossOrigin
    }, [heroImage])


    if (imageSrc) return (
      <PopupEditor title="Hero Image" path={heroImage.path} sources={heroImage} type={type}>
        <div className="image" style={{ position: "relative", minHeight: 80 }}>
          <div style={{ position: "absolute", height: imageHeight, width: "100%" }} className="editable" />
          <img src={imageSrc} className="hero" onLoad={e => imageLoaded(e)} crossOrigin="anonymous" />
        </div>
      </PopupEditor>
    )
    else return (
      <div className="image" style={{ position: "relative", minHeight: 80 }}>
        <PopupEditor title="Hero Image" path={heroImage.path} sources={heroImage} type={type}>
          <PhotoCameraOutlinedIcon className='editIcon' style={{ fontSize: 40, position: "absolute", bottom: 10, right: 10 }} />
        </PopupEditor>
      </div>
    )
  }
  catch (err) {
    throw err
  }
}

export default HeroImage

const getHeroImage = () => {
  try {

    const { classData, objectData, instanceData, scannerInstanceData, passType } = useContext(PassContext)

    switch (passType) {
      case "generic":
        {
          return {
            template_source: "object",
            source: "object",
            path: "heroImage.sourceUri.uri",
            value: dataSelector({ objectData, instanceData, scannerInstanceData, path: "heroImage.sourceUri.uri" })
          }
        }

      case "eventTicket":
      case "flight":
      case "transit":
      case "offer":
      case "loyalty":
      case "giftCard": {
        return {
          template_source: "class",
          source: objectData.heroImage ? "object" : "class",
          path: "heroImage.sourceUri.uri",
          value: objectData.heroImage ? dataSelector({ objectData, instanceData, scannerInstanceData, path: "heroImage.sourceUri.uri" }) : classData.heroImage?.sourceUri?.uri
        }
      }
    }
  }
  catch (err) {
    console.error("Error destructuring hero path")
  }
}